enum SuggestionBoxTypeEnum {
  HiddenSuggestionBox = 0,
  Title = 1,
  Description = 2,
}
export default Object.freeze(SuggestionBoxTypeEnum);

